export const OrderDesValue = 'descending';
export const OrderAscValue = 'ascending';

export const FilterParametersDefault = [
  'name',
  'ndvi',
  'temperature',
  'gdd',
  'humidity',
  'dew',
];